import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { colors, SovosRaisedButton, SovosFlatButton } from 's1-ui';
import TextField from 'commonComponents/textField';
import logo from 'resources/common-white-sovos-shipcompliant-logo.svg';

const { primaryNavy, neutralWhite, buttonOrange } = colors;

const styles = {
  pageContainer: {
    position: 'fixed',
    backgroundColor: primaryNavy,
    height: '100vh',
    width: '100vw',
    overflowY: 'scroll',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column nowrap',
  },
  welcome: {
    fontSize: 35,
    fontWeight: 100,
    color: neutralWhite,
    marginTop: 50
  },
  createText: {
    fontSize: 25,
    fontWeight: 100,
    color: neutralWhite,
    marginTop: 30
  },
  formContainer: {
    marginTop: 20
  },
  createButton: {
    marginTop: 50
  },
  alreadyUser: {
    marginTop: 20,
    display: 'flex',
    alignItems: 'center'
  },
  flatButton: {
    'button&:not(.another):not(.annoying):not(.specificity):not(.contest)': {
      padding: 0,
      textTransform: 'none'
    }
  },
  alreadyText: {
    color: neutralWhite,
    fontWeight: 300
  },
  signInText: {
    fontSize: 18
  },
  terms: {
    fontSize: 11,
    color: neutralWhite,
    fontWeight: 100,
    marginTop: 50
  }
};

// eslint-disable-next-line arrow-body-style
const getOnChange = (parentValue, parentOnChange, key) => {
  return function onChange(newValue) {
    parentOnChange({ ...parentValue, [key]: newValue });
  };
};

const InputField = ({
  value, onChange, label, style, type
}) => (
  <div style={ { paddingTop: 30 } }>
    <TextField
      InputProps={ {
        placeholder: label
      } }
      style={ style }
      label={ label }
      value={ value }
      type={ type }
      onChange={ e => onChange(e.target.value) }
    />
  </div>
);

export const UnstyledCreateOrLogin = ({
  classes, value, onChange, error, onSubmit, signInRedirect, isFormValid
}) => (
  <div className={ `CCP__CreateOrLogin__Container ${classes.pageContainer}` }>
    <div>
      <img
        src={ logo }
        alt="shipcompliant_logo"
        height="50"
      />
    </div>
    <div className={ classes.welcome }>
      Welcome to ShipCompliant Carrier Compliance
    </div>
    <div className={ classes.createText }>
      Create your new account
    </div>
    <div className={ classes.formContainer }>
      <InputField
        value={ value.Email }
        onChange={ getOnChange(value, onChange, 'Email') }
        label="Email"
        style={ { width: 350 } }
      />
      <InputField
        value={ value.Password }
        onChange={ getOnChange(value, onChange, 'Password') }
        label="Password"
        type="password"
        style={ { width: 350 } }
      />
      <InputField
        value={ value.PasswordConfirm }
        onChange={ getOnChange(value, onChange, 'PasswordConfirm') }
        label="Retype Password"
        type="password"
        style={ { width: 350 } }
      />
      { error && <span style={ { color: 'red' } }>{ error }</span>}
    </div>
    <div className={ classes.createButton }>
      <SovosRaisedButton
        color={ neutralWhite }
        backgroundColor={ buttonOrange }
        onClick={ onSubmit }
        disabled={ !isFormValid }
      >
        <span style={ { fontWeight: 300 } }>CREATE ACCOUNT</span>
      </SovosRaisedButton>
    </div>
    <div className={ classes.alreadyUser }>
      <span className={ classes.alreadyText }>I already have an account - </span>
      <SovosFlatButton
        className={ classes.flatButton }
        color={ buttonOrange }
        onClick={ () => signInRedirect() }
      >
        <span className={ classes.signInText }>Sign In</span>
      </SovosFlatButton>
    </div>
    <div className={ classes.terms }>
      By clicking Create Account you agree to our Terms and that you have read our Data Use Policy
    </div>
  </div>
);

UnstyledCreateOrLogin.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  signInRedirect: PropTypes.func.isRequired,
  isFormValid: PropTypes.bool.isRequired
};

InputField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired,
  type: PropTypes.string // eslint-disable-line react/require-default-props
};

InputField.defaultProps = {
  value: '',
};

export default withStyles(styles)(UnstyledCreateOrLogin);
